module.exports = __webpack_public_path__ + "img/home-01.de27ccaf.jpg";